module.exports = __webpack_public_path__ + "static/media/BDBT01.35d48793.jpg";